export default {
	title: "Koleso Šťastia",
	Lucky: "Šťastie",
	wheels: "Kolesá",
	winningrecord: "Záznam výhier",
	ActivityRules: "Pravidlá Aktivity",
	ActivityRulesContent: "Pre viac informácií o žrebovaní kontaktujte našu zákaznícku podporu.",
	award: {
		title: "Gratulujeme k výhre!",
		btn: "Prijať výhru"
	},
	noticeItem: "{0} získal {1}",
	lotteryDraws: "{0} žrebovaní lotérie",
	noAvailableTimes: "Nedostatočný počet pokusov. Kontaktujte zákaznícky servis.",
	noOpen: "Ešte nie je otvorené",
	noWinning: "Pokračujte v snahe",
	ViewALlPrizes: "Zobraziť všetky ceny",
	myPrizes: "Moje ceny",
	share: "Zdieľať s priateľom"
};
